import * as React from "react"
import Stack from "@mui/material/Stack"

const WrapperLinkHover = ({
  title,
  children,
  alignItems = "center",
  justifyContent = "center"
}) => {
  return (
    <Stack
      height="100%"
      alignItems={alignItems}
      justifyContent={justifyContent}
      sx={{
        whiteSpace: "nowrap",
        position: "relative",
        zIndex: 2
      }}
    >
      {children}
    </Stack>
  )
}

export default WrapperLinkHover
